import EnvUtils from "./EnvUtils";

export function initialLetters(name: string) {
  name = name.replace(/\s(de|da|dos|das)\s/g, " ");
  const initials = name.match(/\b(\w)/gi);

  if (initials.length > 1) {
    return (initials[0] + initials[1]).toUpperCase();
  } else {
    return name.substr(0, 2);
  }
}

export function Login() {
  const loginUrl = "https://accounts.pre.superbid.net/";
  const clientID = "dzqC3VodSoXukD45BQKg3NQU6-faststore";

  return `${loginUrl}signin?response_type=token&client_id=${clientID}&redirect_uri=${EnvUtils.getRedirectUri()}&authorization_uri=${EnvUtils.getAuthorizationUri()}&language=pt-BR&portal_id=2`;
}

export function Register() {
  const registerUrl = "https://accounts.pre.superbid.net/";
  const clientID = "dzqC3VodSoXukD45BQKg3NQU6-faststore";

  return `${registerUrl}signup?response_type=token&redirect_uri=${EnvUtils.getRedirectUri()}&authorization_uri=${EnvUtils.getAuthorizationUri()}?authorization_login=userdata&client_id=${clientID}&language=pt-BR&portal_id=2`;
}

function toBRL(value: number) {
  return Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
}

function toBRLWithSymbol(value: number) {
  return value.toLocaleString("pt-br", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
const formatPrice = {
  toBRL,
  toBRLWithSymbol,
};

export default formatPrice;

export function getOnlyNumbers(string: string | number) {
  var numsStr = string.toString();
  var onlyString = numsStr.replace(/[^0-9]/g, "");
  return parseInt(onlyString);
}

export const removeAccents = (word: string): string => {
  return word.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};
